module.exports = __webpack_public_path__ + "media/images/piscine-bcdb34188cd365c58a0fff5b04945539.svg";